import { useState } from "react";
import { ArrowLeft, ArrowUpRight, LockKeyhole } from "lucide-react";
import { Link } from "react-router-dom";
import SeoHead from "@/components/SeoHead";
import { useAuth } from "@/auth/AuthContext";

export default function ForgotPassword() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setSending(true);
    setError("");
    setMessage("");
    try {
      await requestPasswordReset(email);
      setMessage("If an account exists for that email, a recovery link is on its way.");
    } catch {
      setError("We could not send the recovery email. Please try again shortly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="auth-page" data-testid="forgot-password-page">
      <SeoHead title="Reset your password | Ashwini Patil" description="Request a secure password recovery link for your Ashwini Patil account." canonical="https://ashwinipatil.ai/forgot-password" noIndex schemas={[]} />
      <div className="shell auth-shell">
        <Link to="/login" className="inline-link" data-testid="forgot-password-back-link"><ArrowLeft size={15} /> Back to sign in</Link>
        <div className="auth-card">
          <div className="auth-mark"><LockKeyhole size={19} /></div>
          <div className="section-kicker">Account recovery</div>
          <h1 className="auth-title">Find your way back.</h1>
          <p className="auth-copy">Enter your email and we will send a secure link if an account exists.</p>
          <form onSubmit={submit} data-testid="forgot-password-form">
            <label className="form-field"><span className="form-label">Email</span><input className="form-input" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required data-testid="forgot-password-email" /></label>
            <button type="submit" className="button-primary" disabled={sending} data-testid="forgot-password-submit">{sending ? "Sending…" : "Send recovery link"} <ArrowUpRight size={15} /></button>
            <p className="auth-error" role="alert" data-testid="forgot-password-error">{error}</p>
            <p className="auth-success" role="status" data-testid="forgot-password-message">{message}</p>
          </form>
        </div>
      </div>
    </main>
  );
}
